import type { ToastrEmitter } from 'react-redux-toastr';

import getMessageFromError from 'functions/general/getMessageFromError';
import type { ResponseWithData } from 'services/http/types';

const promiseWrapper = (toastr: ToastrEmitter) => <T>(prom: Promise<ResponseWithData<T>> | undefined) => {
  if (!prom) return Promise.reject(new Error('Promise is undefined'));
  return prom.then(response => {
    return Promise.resolve(response.data);
  }).catch((error: unknown) => {
    const message = getMessageFromError(error);
    toastr.error(message, '');
    if (error instanceof Error) return Promise.reject(error);
    return Promise.reject(new Error(message));
  });
}

export default promiseWrapper;
